import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import routes from './routes';
import EndOfWorkdayModal from '../components/EndOfWorkdayModal/EndOfWorkdayModal';

const ProtectedRoute = () => {
  const { token } = JSON.parse(localStorage.getItem('token')) || {};
  const roleName = useSelector((state) => state.getMyProfile.user?.role?.name);
  // uncomment this line if you want to show the modal for assembler_test role
  const isAssemblerSession = roleName && roleName.toLowerCase() === 'assembler_test';

  return token ? (
    <>
      <Outlet />
      {isAssemblerSession ? <EndOfWorkdayModal /> : null}
    </>
  ) : <Navigate to={routes.LOGIN} />;
};

export default ProtectedRoute;
